module.exports = {

  purge: [
    './src/**/*.html',
    './src/**/*.vue',
    // './src/**/*.jsx',
  ],
  
    theme: {
  
      // flexGrow: {
      //    default: 0,
      //   '10': 10,
      // },

      // purge: {
      //   // Learn more on https://tailwindcss.com/docs/controlling-file-size/#removing-unused-css
      //   enabled: process.env.NODE_ENV === 'production',
      //   content: [
          
      //     'components/**/*.vue',
      //     'components-two/**/*.vue',
      //     'components-three/**/*.vue',

      //     'layouts/**/*.vue',
      //     'pages/**/*.vue',
      //     'views/**/*.vue',
      //     'plugins/**/*.js',
      //   ]
      // },
      extend: {
        colors:{
          test: "red",
          myBottomBar:'#43dde6',
          myFocusText:'f0f0f0',
          lightBottomBar:'#b794f4',
      }
      },
    },
    variants: {},
    plugins: [
  
        require('tailwindcss-rtl')
    ],

  }
  
  
  